export const state = {
    locale: null,
    locales: []
};
  
export const mutations = {
  SET_LOCALE(state, payload) {
    state.locale = payload
  },
};